import React, { PureComponent, ReactNode } from "react"
import StyledDiv from './styles'

interface IProps {
  id?: any
  selected: boolean
  icon?: string
  label: string
  description?: string
  disabled?: boolean
  onChange?: (checked: boolean) => void
}

class Radiobutton extends PureComponent<IProps> {
  constructor(props: IProps) {
    super(props)
  }

  public render(): ReactNode {
    const { id, selected, icon, label, description, disabled, onChange } = this.props
    return (
      <StyledDiv>
        <input
          id={ id ?? label }
          name={ id ?? label }
          type="radio"
          checked={ selected }
          disabled={ disabled || false }
          onChange={(checked) => onChange && onChange(checked.target.checked)}
        />
        {
          icon &&
          <img src={icon} />
        }
        <label htmlFor={ id ?? label }>
          { label }
          {
            description &&
            <span> { description }</span>
          }
        </label>
      </StyledDiv>
    )
  }
}

export default Radiobutton